import CryptoJS from 'crypto-js/crypto-js';

const AES_KEY_UPLOAD_PRICE = '12196b9a55e544d3'; // 电商数据上报 价格字段 的秘钥


export function aesEncrypt(text, secKey = AES_KEY_UPLOAD_PRICE, need_hex = true) { // AES加密
  const key = CryptoJS.enc.Utf8.parse(secKey); // 加密秘钥
  const iv = CryptoJS.enc.Utf8.parse(secKey); //  矢量
  const data = CryptoJS.enc.Utf8.parse(text);
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7, // 后台用的是pad.Pkcs5,前端对应为Pkcs7
  });
  return need_hex ? encrypted.ciphertext.toString() : encrypted.toString();
}

export function aesDecrypt(text, secKey = AES_KEY_UPLOAD_PRICE, need_hex = true) { //  AES解密
  let src = text;
  if (need_hex) {
    const encryptedHexStr = CryptoJS.enc.Hex.parse(text);
    src = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  }
  const key = CryptoJS.enc.Utf8.parse(secKey);
  const iv = CryptoJS.enc.Utf8.parse(secKey);
  const decryptResult = CryptoJS.AES.decrypt(src, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decryptResult.toString(CryptoJS.enc.Utf8);
}
